<template>
  <section class="today">
    <Block
      v-if="!isLogined || !courseList.length"
      :isLogined="isLogined"
      @handleLogin="handleLogin"
    />
    <List
      v-else
      :courseList="courseList"
    />
    <Boutique
      v-if="!isPrivilege && popularCourses.length && !courseList.length" :popularCourses="popularCourses"
    />
  </section>
</template>

<script>
import api from '@edu-fe/api'
import module from '../modules/today'
import { mapState, mapActions } from 'vuex'
import login from '@/utils/login'
import ShareMaker from '../lib/shareMaker'
import Boutique from '../components/Today/Boutique'
import Block from '../components/Today/Block'
import List from '../components/Today/List'
import os from '@edu-fe/os'
import { downloadApp, isxxx } from '@mixins'

export default {
  name: 'Today',
  data () {
    return {
      isLogined: null
    }
  },
  computed: {
    ...mapState(['isPrivilege', 'vipOperationList']),
    ...mapState({
      courseList: state => state[module.name].courseList,
      status: state => state[module.name].status,
      popularCourses: state => state[module.name].popularCourses,
    }),
    queryFrom () {
      return this.$route.query.from
    }
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  created () {
    login.login()
    this.init()
  },
  mixins: [
    downloadApp,
    isxxx
  ],
  mounted () {
    /* eslint-disable */
    new ShareMaker({
      title: '微课',
      introduction: '职业的发展取决于，工作8小时之外的学习，微课助力职场，成就精英！',
      imgUrl: this.$store.state.organizationMessage.organLogo,
      link: `https://course-m.auoktalk.com/recommend/?appId=${window.localStorage.getItem('wkAppId')}`
    }, location.href, true)
  },
  beforeDestroy () {
    this.$loading.hide()
    this.$store.unregisterModule(module.name)
  },
  methods: {
    ...mapActions([
      'today/getCourseList',
      'today/getPopularCourses',
      'getPrivilege'
    ]),
    async init () {
      if (!this.courseList.length) {
        this.$loading.show()
      }

      if (login.getWpsSid()) {
        this.isLogined = login.getWpsSid()
        if (!this.vipOperationList.length) {
          this['getPrivilege']()
        }
        this.$loading.hide()
      }

      await this['today/getCourseList']()
      await this['today/getPopularCourses']()
    },
    handleGotoLive (url) {
      this.$router.push(url)
    },
    handleNavigate (url) {
      this.$router.push(url)
    },
    handleGotoDetail (course) {
      // 区分音/视频详情
      switch (course.type) {
        case 1: // 视频
          this.$router.push(`/video-detail?courseId=${course.courseId}&chapterId=${course.chapterId}`)
          break
        case 2: // 音频
          this.$router.push(`/audio-detail?courseId=${course.courseId}&chapterId=${course.chapterId}`)
          break
        default:
          this.$router.push(`/schedule?courseId=${course.courseId}`)
      }
    },
    handleLogin () {
      login.login()
    }
  },
  components: {
    Boutique,
    Block,
    List
  }
}
</script>

<style lang="scss">
@charset 'UTF-8';
@import '../style/main';

$global-width: 750;

.today {
  position: relative;
  height: 100vh;
  font-family: PingFangSC-Regular;
  color: #666;
  overflow: scroll;
  padding-bottom: rem(98);
  &-download {
    width: 100%;
    > img {
      width: 100%;
    }
  }
  &-topbar {
    width: rem(690);
    margin: auto;
    > img {
      width: 100%;
    }
  }
  &-filter {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    filter: blur(10px);
    background: url('http://edu-wps-cn.ks3-cn-beijing.ksyun.com/static_file/pictures/combine_course/8b0b6b2b06ee456dc0f38c95f79fd624.jpg') #000;
  }

  &-swiper {

    &-wrapper {
      /*overflow: hidden;*/
      /*height: 100%;*/
      border-radius: 6px;
      /*background-color: #f3f4f6;*/
    }

    &-list {
      overflow-y: scroll;
      box-sizing: border-box;
      padding: rem(40) rem(30) rem(120);
      height: 100%;
      border-radius: 6px;

      & > li {
        position: relative;
        // padding: rem(30) rem(30) rem(50);
        padding: rem(30);
        // padding-right: rem(0);
        border-radius: 6px;
        background-color: #fff;

        &:not(:first-child) {
          margin-top: rem(30);
        }

        & > div {
          display: inline-block;
          vertical-align: top;

          &:last-child {
            width: rem(450);
          }
        }
      }

      &-image {
        margin-right: rem(20);
        width: rem(155);

        & > img {
          display: block;
          width: 100%;
        }
      }

      &-course {
        // margin-bottom: rem(56);
        line-height: 1.5;

        & > p {

          &:first-child {
            font-size: rem(30);
            font-weight: bold;
            color: #333;
          }

          &:last-child {
            font-size: rem(24);
            color: #666;
          }
        }
      }

      &-button {
        position: absolute;
        bottom: rem(30);

        & > div {
          display: inline-block;
          box-sizing: border-box;
          vertical-align: middle;
          margin-right: rem(20);
          width: rem(145);
          height: rem(55);
          line-height: rem(55);
          text-align: center;
          background-color: #aeaeae;
          color: #fff;
          font-weight: bold;;
        }
        & p{
          display: inline-block;
          box-sizing: border-box;
          vertical-align: middle;
          margin-right: rem(20);
          width: rem(140);
          height: rem(50);
          line-height: rem(50);
          border-radius: 3px;
          text-align: center;

          $color: #f48f00;

          &:first-child {
            border: 1px solid $color;
            color: $color;
          }

          &:last-child {
            background-color: $color;
            color: #fff;
          }

          &.disable {
            border-radius: 3px;
            border: none;
            background-color: #aeaeae;
            color: #fff;
          }
        }
      }
    }

    /** list end **/

    &-buy {
      // margin: rem(100) rem(30) 0;
      margin: rem(100) auto 0;
      padding: rem(724) 0 rem(94);
      width: rem(660);
      border-radius: 6px;
      background: url('../assets/images/today-login-bg.png') #fff center rem(72) no-repeat;
      background-size: rem(454) rem(520);

      &-button {
        margin: 0 auto;
        width: rem(460);
        height: rem(80);
        background: url('../assets/images/today-buy-button.png') no-repeat;
        background-size: cover;
      }
    }

    /** buy end **/

    &-login {
      position: relative;
      margin: rem(100) auto 0;
      width: rem(660);
      height: rem(898);
      background: url('../assets/images/today-login-image.png') no-repeat;
      background-size: cover;

      &-button {
        position: absolute;
        bottom: rem(130);
        left: rem(100);
        width: rem(460);
        height: rem(80);
        background: url('../assets/images/today-login-button.png') no-repeat;
        background-size: cover;
      }
    }
  }
}

$global-width: 720;
</style>
